import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  size?: number;
};
const GithubIcon: FC<Props> = ({ size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill={colors['--pink-500']}
      fillRule="evenodd"
      d="M8 0C3.58 0 0 3.67 0 8.202c0 3.63 2.29 6.696 5.47 7.782.4.072.55-.174.55-.39 0-.194-.01-.84-.01-1.527-2.01.38-2.53-.502-2.69-.964-.09-.236-.48-.963-.82-1.158-.28-.154-.68-.534-.01-.544.63-.01 1.08.595 1.23.841.72 1.24 1.87.892 2.33.677.07-.534.28-.892.51-1.097-1.78-.205-3.64-.913-3.64-4.05 0-.892.31-1.63.82-2.205-.08-.205-.36-1.045.08-2.173 0 0 .67-.216 2.2.84a7.252 7.252 0 012-.276c.68 0 1.36.092 2 .276 1.53-1.066 2.2-.84 2.2-.84.44 1.128.16 1.968.08 2.173.51.575.82 1.302.82 2.205 0 3.147-1.87 3.845-3.65 4.05.29.256.54.748.54 1.517 0 1.097-.01 1.979-.01 2.256 0 .215.15.471.55.39a8.031 8.031 0 003.946-2.993A8.359 8.359 0 0016 8.202C16 3.671 12.42 0 8 0z"
      clipRule="evenodd"
    />
  </svg>
);

export default GithubIcon;
